import { AgendaShift } from "../../../graphql/API";

const useDateService = () => {

    const getTIMEZONE = () => {
        const offsetInMinutes = new Date().getTimezoneOffset(); //ex: -120 pour UTC+2
        const offsetInHours = -offsetInMinutes / 60; // ex: 2
        return offsetInHours
    }

    const getDateWithTimezone = (date: string, TIMEZONE: number) => {
        const now = new Date(date);
        now.setHours(now.getHours() + TIMEZONE); // +5 hours
        return now.toISOString().split("T")[0]; // Keep only the date
    };

    const getDateTimeWithTimezone = (date: string, TIMEZONE: number) => {
        const now = new Date(date);
        now.setHours(now.getHours() + TIMEZONE); // +5 hours
        return now.toISOString(); // Keep only the date
    };
    
    const getMondayOfWeek = (date: Date) => {
        const day = date.getDay();
        const diff = day === 0 ? -7 : 0 - day; 
        const monday = new Date(date);
        monday.setDate(date.getDate() + diff); 
        
        const mondayWithTimeZone = monday.toISOString().split('T')[0] + "T23:59:59.999Z";
        return mondayWithTimeZone;
    }

    function getNextMonday(date: Date) {
        const day = date.getDay(); // actual Day (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
        const diff = (day === 0 ? 1 : 8 - day); // if today it's sunday, +1 day, otherwise + (8 - actual day)
        const nextMonday = new Date(date);
        nextMonday.setDate(date.getDate() + diff);

        const nextMondayWithTimeZone = nextMonday.toISOString().split('T')[0] + "T00:00:00.000Z";
        return nextMondayWithTimeZone;
    }
    
    const getSecondNextMonday = (date: Date) => {
        const day = date.getDay(); // actual Day (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
        const diff = (day === 0 ? 1 : 8 - day); // if today it's sunday, +1 day, otherwise + (8 - actual day)
        const nextSecondMonday = new Date(date);
        nextSecondMonday.setDate(date.getDate() + diff + 7);
        
        const nextSecondMondayWithTimeZone = nextSecondMonday.toISOString().split('T')[0] + "T00:00:00.000Z";
        return nextSecondMondayWithTimeZone;
    }

    const getPastDate = (day: number) => {   
        const date = new Date();
        date.setDate(date.getDate() - day);
        const formattedDate = date.toISOString().split("T")[0] + "T00:00:00.000Z";
        return formattedDate;
    }
    
    const getDateNow = (date: Date, timezone: number) => {
        date.setHours(date.getHours() + timezone);
        return date.toISOString();
    }
    
    const getTotalHoursAndMinutes = (shifts: AgendaShift[]) => {
        let totalMinutes = 0;
        // console.log(shifts);
        for (const shift of shifts) {
        const start = shift.startAt ? new Date(shift.startAt) : new Date(0); // Default to epoch if invalid
        const stop = new Date(shift.stopAt ?? 0); // Default to epoch if invalid
    
        const diffMs = stop.getTime() - start.getTime(); // Diff en millisecondes
        const diffMinutes = Math.floor(diffMs / 60000); // Convertir en minutes
    
        totalMinutes += diffMinutes;
        }
    
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;
    
        return { hours, minutes };
    }

    const getStartDate = () => {
        const currentDate = new Date();
        const date100YearsAgo = new Date(currentDate.setFullYear(currentDate.getFullYear() - 100));
        const isoString100YearsAgo = date100YearsAgo.toISOString();
    
        return isoString100YearsAgo;
    }

    function getDateMinusDays(dateString: string, days: number) {
        const date = new Date(dateString);
        date.setDate(date.getDate() - days);
        return date.toISOString().split('T')[0]; // Format YYYY-MM-DD
    }
    
    function getDatePlusDays(dateString: string, days: number) {
        const date = new Date(dateString);
        date.setDate(date.getDate() + days);
        return date.toISOString().split('T')[0] + "T00:00:00.000Z"; // Format YYYY-MM-DD
    }

     const isNowGreater = (date: Date, timezone: number) => {
        const now = new Date();
        const localNow = new Date(now.getTime() + timezone * 60 * 60 * 1000);
        const localDate = new Date(date.getTime());
        return localNow > localDate;
    };

    return {
        getTIMEZONE, getDateWithTimezone, getDateTimeWithTimezone, 
        getMondayOfWeek, getNextMonday, getSecondNextMonday, 
        getPastDate, getDateNow, getTotalHoursAndMinutes, 
        getStartDate, getDateMinusDays, getDatePlusDays, isNowGreater
    };
  };
  
  export default useDateService;